module.exports = __webpack_public_path__ + "static/img/coupon-product-box02.70eda718.svg";